import { createRouter, createWebHistory } from 'vue-router'
import { i18n } from '../i18n'
import LayoutBase from 'layouts/LayoutBase.vue'
import LayoutBaseAdmin from 'layouts/LayoutBaseAdmin.vue'
import PageGeneric from 'pages/PageGeneric.vue'
import PageHomeAdmin from 'pages/Admin/PageHome.vue'
import PagePerguntas from 'pages/PagePerguntas.vue'

function setTitle(to, from, next) {
  const t = i18n.global.t
  const title = t(to.meta?.title)
  const assessment = window.context.assessment
  document.title = `${assessment.nome_fantasia} ${title ? `- ${title}` : ''}`
  next()
}

const routes = [
  {
    path: '/:assessment/v',
    name: 'home',
    component: LayoutBase,
    children: [
      {
        name: 'pergunta',
        path: 'pergunta/:id',
        component: PagePerguntas,
        beforeEnter: setTitle,
        meta: {
          title: 'questionnaire',
        },
      },
      {
        name: 'PageGeneric',
        path: 'g/:id',
        component: PageGeneric,
      },
    ],
  },
  {
    path: '/v',
    component: LayoutBaseAdmin,
    children: [
      {
        alias: '/v',
        name: 'home_admin',
        path: 'home',
        component: PageHomeAdmin,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
